import { useLanguage } from "../context/LanguageContext";
import PolicyPage, { type PolicyContent } from "./PolicyPage";
import { CONTACT_BIN } from "../data/contact";

const CONTENT: Record<"ru" | "kz", PolicyContent> = {
  ru: {
    title: "Публичная оферта",
    updated: "Дата последнего обновления: 31 августа 2026 г.",
    intro: [
      `Настоящая Оферта является предложением ТОО «БАРКРАФТ» (БИН: ${CONTACT_BIN}) заключить договор поставки.`,
    ],
    sections: [
      {
        heading: "1. Цены",
        paragraphs: [
          "Все цены на сайте указаны с учетом НДС 16%. Окончательная стоимость фиксируется в Счете.",
        ],
      },
      {
        heading: "2. Оплата",
        paragraphs: ["Условия и сроки оплаты согласовываются индивидуально с каждым Покупателем."],
      },
      {
        heading: "3. Поставка",
        paragraphs: [
          "Сроки отгрузки: 10 рабочих дней для товаров в наличии и до 90 календарных дней для товаров под заказ.",
        ],
      },
      {
        heading: "4. Отказ от товара",
        paragraphs: ["При отказе от оплаченного товара, находящегося в пути, взимается штраф в размере 30%."],
      },
      {
        heading: "5. Юрисдикция",
        paragraphs: ["Все споры решаются в Арбитражном суде г. Астана."],
      },
    ],
  },
  kz: {
    title: "Жария оферта",
    updated: "Соңғы жаңарту күні: 2026 жылғы 31 тамыз",
    intro: [
      `Осы Оферта «БАРКРАФТ» ЖШС-ның (БСН: ${CONTACT_BIN}) жеткізу шартын жасасу туралы ұсынысы болып табылады.`,
    ],
    sections: [
      {
        heading: "1. Бағалар",
        paragraphs: ["Сайттағы барлық бағалар 16% ҚҚС ескеріле отырып көрсетілген. Түпкілікті құн Шотта бекітіледі."],
      },
      {
        heading: "2. Төлем",
        paragraphs: ["Төлеу шарттары мен мерзімдері әрбір Сатып алушымен жеке келісіледі."],
      },
      {
        heading: "3. Жеткізу",
        paragraphs: [
          "Жөнелту мерзімдері: бар тауарлар үшін 10 жұмыс күні, тапсырыс бойынша тауарлар үшін 90 күнтізбелік күнге дейін.",
        ],
      },
      {
        heading: "4. Тауардан бас тарту",
        paragraphs: ["Жолда тұрған төленген тауардан бас тартылған жағдайда 30% мөлшерінде айыппұл алынады."],
      },
      {
        heading: "5. Юрисдикция",
        paragraphs: ["Барлық даулар Астана қаласының Арбитраждық сотында шешіледі."],
      },
    ],
  },
};

export default function TermsPage() {
  const { language } = useLanguage();
  return <PolicyPage content={CONTENT[language]} />;
}
